import { render, staticRenderFns } from "./NewCategoryModal.vue?vue&type=template&id=7c6830f0&"
import script from "./NewCategoryModal.vue?vue&type=script&lang=js&"
export * from "./NewCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./NewCategoryModal.vue?vue&type=style&index=0&id=7c6830f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports